// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#promotion-component .divider {\n  border: none;\n  border-top: 1px solid #ededed;\n}\n\n#promotion-component .ql-editor {\n  height: 250px !important;\n}\n", ""]);
// Exports
module.exports = exports;
